import { render, staticRenderFns } from "./bxpgdet.vue?vue&type=template&id=c3ad46d2&scoped=true&"
import script from "./bxpgdet.vue?vue&type=script&lang=js&"
export * from "./bxpgdet.vue?vue&type=script&lang=js&"
import style0 from "./bxpgdet.vue?vue&type=style&index=0&id=c3ad46d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ad46d2",
  null
  
)

export default component.exports